$eve_app_page_libraries $eve_page
	title \Libraries
	Head null
	body /
		<= Main $eve_flex
			direction \column
			gap \1.25rem
			sub /
				<= How_title $eve_text
					text_variant \headingSm
					content <= how_to_title \
				<= How_body $eve_text
					content <= how_to_body \
